// B1.5: thin facade — `api` instance and mixin assembly only.
import { ApiClientCore, API_URL } from './http/core';
import { applyMixins } from './mixins';
import { AuthApi } from './auth';
import { LocationsApi } from './locations';
import { OrgApi } from './org';
import { EmployeesApi } from './employees';
import { DashboardApi } from './dashboard';
import { ShiftsApi } from './shifts';
import { TasksApi } from './tasks';
import { SchedulesApi } from './schedules';
import { IncidentsApi } from './incidents';
import { SupportPlatformApi } from './support_platform';
import { HrPositionsApi } from './hr_positions';
import { InstructionsApi } from './instructions';
import { AnalyticsApi } from './analytics';
import { AuditApi } from './audit';
import { BreaksApi } from './breaks';
import { ChatApi } from './chat';
import { ChecklistsApi } from './checklists';
import { ConsumablesApi } from './consumables';
import { CounterpartiesApi } from './counterparties';
import { DocumentsApi } from './documents';
import { FilesApi } from './files';
import { ProductUpdatesApi } from './product_updates';
import { SalaryPayrollApi } from './salary_payroll';
import { WalletApi } from './wallet';
import { OtherApi } from './other';
import { AiApi } from './ai';

export class ApiClient extends ApiClientCore {}

export interface ApiClient
  extends AuthApi,
    LocationsApi,
    OrgApi,
    EmployeesApi,
    DashboardApi,
    ShiftsApi,
    TasksApi,
    SchedulesApi,
    IncidentsApi,
    SupportPlatformApi,
    HrPositionsApi,
    InstructionsApi,
    AnalyticsApi,
    AuditApi,
    BreaksApi,
    ChatApi,
    ChecklistsApi,
    ConsumablesApi,
    CounterpartiesApi,
    DocumentsApi,
    FilesApi,
    ProductUpdatesApi,
    SalaryPayrollApi,
    WalletApi,
    OtherApi,
    AiApi {}

applyMixins(
  ApiClient,
  AuthApi,
  LocationsApi,
  OrgApi,
  EmployeesApi,
  DashboardApi,
  ShiftsApi,
  TasksApi,
  SchedulesApi,
  IncidentsApi,
  SupportPlatformApi,
  HrPositionsApi,
  InstructionsApi,
  AnalyticsApi,
  AuditApi,
  BreaksApi,
  ChatApi,
  ChecklistsApi,
  ConsumablesApi,
  CounterpartiesApi,
  DocumentsApi,
  FilesApi,
  ProductUpdatesApi,
  SalaryPayrollApi,
  WalletApi,
  OtherApi,
  AiApi
);

export const api = new ApiClient(API_URL);
